// extracted by mini-css-extract-plugin
module.exports = {"add_task":"addtask_add_task__350GZ","add_task_form":"addtask_add_task_form__1Kc9P","block":"addtask_block__22cVH","subheading":"addtask_subheading__1HL0_"};